import React from "react";
import { Container } from "react-bootstrap";

const PitchCF = () => {
  return (
    <>
      <section className="py-5">
        <Container>
          <p className="section-subtitle  text-start mb-2 px-3 pb-3">
            Cash Flows
          </p>
          {/* first table */}
          <div className="scroll-x">
            <table className="custom-table">
              <thead>
                <tr>
                  <th>Description</th>
                  <th>Year 01</th>
                  <th>Year 02</th>
                  <th>Year 03</th>
                  <th>Year 04</th>
                  <th>Year 05</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td colSpan={6} className="lead-cell">
                    Net Cash Flow from Operations
                  </td>
                </tr>
                <tr>
                  <td>Net Profit</td>
                  <td> $2,552,274,039</td>
                  <td> $15,410,431,575</td>
                  <td> $37,736,354,520</td>
                  <td> $64,340,361,720</td>
                  <td> $107,561,907,000</td>
                </tr>
                <tr>
                  <td>Depreciation & Amortization</td>
                  <td> $2,520,000</td>
                  <td> $9,000,000</td>
                  <td> $17,640,000</td>
                  <td> $26,280,000</td>
                  <td> $36,360,000</td>
                </tr>
                <tr>
                  <td colSpan={6}>Change in Accounts Receivable</td>
                </tr>
                <tr>
                  <td colSpan={6}>Change in Inventory</td>
                </tr>
                <tr>
                  <td colSpan={6}>Change in Accounts Payable</td>
                </tr>
                <tr>
                  <td colSpan={6}>Change in Income Tax Payable</td>
                </tr>
                <tr>
                  <td colSpan={6}>Change in Sales Tax Payable</td>
                </tr>
                <tr>
                  <td colSpan={6}>Change in Prepaid Revenue</td>
                </tr>
                <tr className="lead-row">
                  <td>Net Cash Flow from Operations</td>
                  <td> $2,554,794,039</td>
                  <td> $15,419,431,575</td>
                  <td> $37,753,994,520</td>
                  <td> $64,366,641,720</td>
                  <td> $107,598,267,000</td>
                </tr>
                <tr>
                  <td colSpan={6} className="lead-cell">
                    Investing & Financing
                  </td>
                </tr>
                <tr>
                  <td>Assets Purchased or Sold (CAPEX)</td>
                  <td> $(84,000,000)</td>
                  <td> $(216,000,000)</td>
                  <td> $(288,000,000)</td>
                  <td> $(288,000,000)</td>
                  <td> $(336,000,000)</td>
                </tr>
                <tr>
                  <td>Owner's Equity</td>
                  <td> $5,190,005,961</td>
                  <td> $9,302,080,251</td>
                  <td> $3,794,823,813</td>
                  <td>$</td>
                  <td>$</td>
                </tr>
                <tr>
                  <td>Change in Long-Term Debt</td>
                  <td>$</td>
                  <td>$</td>
                  <td>$</td>
                  <td>$</td>
                  <td>$</td>
                </tr>
                <tr>
                  <td>Change in Short-Term Debt</td>
                  <td>$</td>
                  <td>$</td>
                  <td>$</td>
                  <td>$</td>
                  <td>$</td>
                </tr>
                <tr className="lead-row">
                  <td>Net Cash Flow from Investing & Financing</td>
                  <td> $5,106,005,961</td>
                  <td> $9,086,080,251</td>
                  <td> $3,506,823,813</td>
                  <td> $(288,000,000)</td>
                  <td> $(336,000,000)</td>
                </tr>
                <tr>
                  <td>Cash at Beginning of Period</td>
                  <td>$</td>
                  <td> $7,660,800,000</td>
                  <td> $32,166,311,826</td>
                  <td> $73,427,130,159</td>
                  <td> $137,505,771,879</td>
                </tr>
                <tr className="lead-row">
                  <td>Net Change in Cash</td>
                  <td> $7,660,800,000</td>
                  <td> $24,505,511,826</td>
                  <td> $41,260,818,333</td>
                  <td> $64,078,641,720</td>
                  <td> $107,262,267,000</td>
                </tr>
                <tr className="lead-row">
                  <td>Cash at End of Period</td>
                  <td> $7,660,800,000</td>
                  <td> $32,166,311,826</td>
                  <td> $73,427,130,159</td>
                  <td> $137,505,771,879</td>
                  <td> $244,768,038,879</td>
                </tr>
                <tr className="active">
                  <td>Assumed Owner's Equity</td>
                  <td className="lead-cell"> $5,190,005,961</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </div>
        </Container>
      </section>
    </>
  );
};

export default PitchCF;
